import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";

type GridProps = {
	fontSize: number;
	lineGap: number;
	columns?: {
		contentWidth: number;
		count: number;
		gutter: number;
	};
} & typeof defaultProps;

const Wrap = styled.div`
	position: relative;
	z-index: 9;
	width: 100%;
	height: 100%;
	pointer-events: none;
`;
const Frame = styled.svg`
	width: 100%;
`;
const GridGuide: React.FC<GridProps> = ({ fontSize, lineGap, columns }) => {
	const wrapRef = useRef<HTMLDivElement>(null);
	const [containerSize, setContainerSize] = useState({ width: 0, height: 0 });
	useEffect(() => {
		const updateContainerSize = () => {
			//動的に高さを決める要素の為にタイミングをずらす
			setTimeout(() => {
				if (wrapRef.current) {
					setContainerSize(wrapRef?.current?.getBoundingClientRect());
				}
			}, 0);
		};
		updateContainerSize();
		window.addEventListener("resize", updateContainerSize);
		return () => {
			window.removeEventListener("resize", updateContainerSize);
		};
	}, []);
	const columnMargin =
		(Math.floor(containerSize.width / fontSize) * fontSize -
			columns.contentWidth) /
		2;
	const columnWidth =
		(columns.contentWidth - columns.gutter * (columns.count - 1)) /
		columns.count;
	return (
		<Wrap ref={wrapRef}>
			<Frame
				viewBox={`0 0 ${containerSize.width} ${containerSize.height}`}
				style={{
					display: "block",
					width: containerSize.width - (containerSize.width % fontSize),
					height: containerSize.height,
				}}
			>
				{new Array(columns.count).fill(null).map((_, index) => (
					<rect
						x={columnMargin + (columnWidth + columns.gutter) * index}
						y="0"
						fill="hsla(0, 100%, 70%, 0.1)"
						width={columnWidth}
						height="100%"
						key={`column${index}`}
					/>
				))}
				{new Array(Math.trunc(containerSize.width / fontSize) + 1)
					.fill(null)
					.map((_, index) => {
						const x = fontSize * index;
						return (
							<>
								<line
									x1={x}
									y1="0"
									x2={x}
									y2="100%"
									stroke="hsla(0, 100%, 60%, 0.6)"
									key={`vGrid${index}`}
								/>
								<line
									x1={x + fontSize / 2}
									y1="0"
									x2={x + fontSize / 2}
									y2="100%"
									stroke="hsla(0, 100%, 60%, 0.2)"
									key={`vGridSub${index}`}
								/>
							</>
						);
					})}
				{new Array(Math.ceil(containerSize.height / (fontSize + lineGap)))
					.fill(null)
					.reduce((acc, _, index) => {
						const y = (fontSize + lineGap) * index;
						acc.push(
							<rect
								y={y}
								fill={"hsla(0, 0%, 70%, 0.1)"}
								width="100%"
								height={fontSize}
								key={`hGrid${index}`}
							/>
						);
						return acc;
					}, [])}
			</Frame>
		</Wrap>
	);
};
const defaultProps = {
	columns: { contentWidth: 1136, count: 12, gutter: 16 },
};
GridGuide.defaultProps = defaultProps;

export default GridGuide;
